
      function makeVersion() {
        let info = __BUILD_INFO__;

        console.log("buildInfo", info);

        let versionDiv = document.querySelector("#version");
        versionDiv.innerText = `v${info.version}-${info.revision}`

        if (info.dirty) {
            versionDiv.innerText += "-dirty"
        }

        versionDiv.innerText += ` (${info.time})`
      }
      makeVersion();
    